import { Component, OnInit } from "@angular/core";
import { Constant } from "../@theme/components/auth/constant/constant";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-terms-and-conditions",
  templateUrl: "./vta.terms-and-conditions.component.html",
  styleUrls: ["./vta.terms-and-conditions.component.scss"],
})
export class TermsAndConditionsComponent implements OnInit {
  constructor(private constant: Constant, private router: Router) {}

  ngOnInit(): void {}

  goToDashboard() {
    this.router.navigateByUrl(this.constant.REDIRECT_LINKS.DASHBOARD);
  }
}
